exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2OGIv0kTNGh_spAWFr4RlT,._2OGIv0kTNGh_spAWFr4RlT i{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"snoozeSubMenuButton": "_2OGIv0kTNGh_spAWFr4RlT"
};